import { render, staticRenderFns } from "./CustomerRoles.vue?vue&type=template&id=765d8c1d"
import script from "./CustomerRoles.vue?vue&type=script&lang=js"
export * from "./CustomerRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports